<template>
  <div class="locacao-container">

    <!-- Navegação por Ícones -->
    <CardNavLocacao :pasta="pasta" class="mb-4" />

    <form method="POST" ref="formulario" @submit.prevent.stop="add">
      <input type="hidden" name="acao" :value="acao"/>

      <!-- Cabeçalho -->
      <div class="card locacao-card mb-4">
        <div class="locacao-card-header d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Ficha de Locação</h3>
          <router-link :to="`/buscaLocacoes`" class="btn btn-lista-locacoes">Lista locações</router-link>
        </div>
        <div class="locacao-card-body" v-if="acao==2">
          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div>
              <span class="badge-campo"><strong>Pasta:</strong> {{ pasta }}</span>
              <span class="mx-2 text-muted">|</span>
              <span class="badge-campo"><strong>Referência do Imóvel:</strong> {{ referencia }}</span>
              <button @click="showImovel" type="button" class="btn btn-visualizar ml-2">Visualizar</button>
            </div>
          </div>
        </div>
        <div class="locacao-card-body" v-else>
          <span class="text-muted">Nova ficha de locação</span>
        </div>
      </div>

      <!-- Dados do Contrato -->
      <div class="card locacao-card mb-4">
        <div class="locacao-card-header">
          <h5 class="mb-0">Dados do Contrato</h5>
        </div>
        <div class="locacao-card-body">
          <div class="row">
            <div class="form-group col-sm-1">
              <label>Pasta:</label>
              <input type="text" name="pasta" class="form-control" value="" v-model="pasta">
            </div>
            <div class="form-group col-sm-2">
              <label>Referência:</label>
              <input type="text" name="referencia" class="form-control" value="" v-model="referencia">
            </div>
            <div class="form-group col-sm-3">
              <label>Garantia:</label>
              <select class="form-control" name="garantia" v-model="garantia">
                <option value="">Nenhuma</option>
                <option value="Fiador">Fiador</option>
                <option value="Titulo">Titulo</option>
                <option value="Seguro">Seguro</option>
                <option value="Caução">Caução</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label>Índice de reajuste:</label>
              <select class="form-control" name="garantia" v-model="reajuste">
                <option value="">Nenhum</option>
                <option value="INPC">INPC</option>
                <option value="IPCA">IPCA</option>
                <option value="IGPM">IGPM</option>
                <option value="Outros">Outros</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label>Meses de contrato:</label>
              <input type="text" name="tempo" class="form-control" v-model="tempo">
            </div>
            <div class="form-group col-sm-2">
              <label>Dia vencimento:</label>
              <input type="text" name="dia" class="form-control" v-model="dia">
            </div>
          </div>
        </div>
      </div>

      <!-- Datas -->
      <div class="card locacao-card mb-4">
        <div class="locacao-card-header">
          <h5 class="mb-0">Datas do contrato</h5>
        </div>
        <div class="locacao-card-body">
          <div class="row">
            <div class="form-group col-sm-3">
              <label>Data Renovação:</label>
              <Datepicker show-clear-button placeholder="Data Renovação" v-model="renovacaoContrato" lang="pt-br" date-format="formato"/>
            </div>
            <div class="form-group col-sm-3">
              <label>Início do contrato:</label>
              <Datepicker show-clear-button placeholder="Data Início" v-model="selectedDate" lang="pt-br" date-format="formato"/>
            </div>
            <div class="form-group col-sm-3">
              <label>Término do contrato:</label>
              <input type="text" class="form-control" :value="fimContrato" readonly />
            </div>
          </div>
        </div>
      </div>

      <!-- Valores -->
      <div class="card locacao-card mb-4">
        <div class="locacao-card-header">
          <h5 class="mb-0">Valores</h5>
        </div>
        <div class="locacao-card-body">
          <div class="row">
            <div class="form-group col-sm-3">
              <label>Valor Aluguel:</label>
              <input type="text" name="valor" class="form-control" v-money="money" v-model.lazy="valor" />
            </div>
            <div class="form-group col-sm-3">
              <label>Renovação Aluguel:</label>
              <Datepicker show-clear-button placeholder="Data Renovação Aluguel" v-model="renovacaoAluguel" lang="pt-br" date-format="formato"/>
            </div>
            <div class="form-group col-sm-2">
              <label>% Adm:</label>
              <input type="number" name="porcentagem" class="form-control" v-model="porcentagem">
            </div>
            <div class="form-group col-sm-2">
              <label>Valor Adm:</label>
              <input type="text" name="valor3" class="form-control" v-money="money" v-model.lazy="valorTaxa" readonly/>
            </div>
            <div class="form-group col-sm-2">
              <label>Valor Boleto:</label>
              <input type="text" name="valor2" class="form-control" v-money="money" v-model.lazy="valor2" />
            </div>
          </div>
        </div>
      </div>

      <!-- Seguro e Responsabilidade -->
      <div class="row mb-5">
        <div class="col-sm-8">
          <div class="card locacao-card mb-4 h-100">
            <div class="locacao-card-header">
              <h5 class="mb-0">Seguro incêndio e Responsabilidade</h5>
            </div>
            <div class="locacao-card-body">
              <div class="row">
                <div class="form-group col-sm-4">
                  <label>Responsável:</label>
                  <select class="form-control" name="garantia" v-model="responsavel">
                    <option value="">Nenhum</option>
                    <option value="Imobiliária">Imobiliária</option>
                    <option value="Locatário">Locatário</option>
                  </select>
                </div>
                <div class="form-group col-sm-4">
                  <label>Seguro Incêndio:</label>
                  <Datepicker show-clear-button placeholder="Renovado até" v-model="renovadoAte" lang="pt-br" date-format="formato"/>
                </div>
                <div class="form-group col-sm-4">
                  <label>Dias p/ renovação:</label>
                  <input type="text" class="form-control" :value="diasRenovacaoCalc" :class="{ 'campo-vencido': renovacaoVencida, 'campo-ok': !renovacaoVencida && diasRenovacaoCalc !== '' }" readonly />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="card locacao-card mb-4 h-100">
            <div class="locacao-card-header">
              <h5 class="mb-0">Repasse / PIX</h5>
            </div>
            <div class="locacao-card-body">
              <div class="form-group">
                <label>Chave PIX:</label>
                <select name="chavePix" v-model="pix" class="form-control">
                  <option value="CPF">CPF</option>
                  <option value="E-MAIL">E-MAIL</option>
                  <option value="TELEFONE">TELEFONE</option>
                </select>
              </div>
              <div class="form-group mb-0">
                <label>Chave:</label>
                <input type="text" v-model="repasse" placeholder="Chave Pix" class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Locador / Locatário -->
      <div class="row mb-5">
        <!-- Dados Locador -->
        <div class="col-sm-6">
          <div class="card locacao-card mb-4 h-100">
            <div class="locacao-card-header">
              <h5 class="mb-0">Dados do Locador</h5>
            </div>
            <div class="locacao-card-body">
              <div class="form-group">
                <label>Nome:</label>
                <input type="text" v-model="locadorNome" class="form-control"/>
              </div>
              <div class="form-group">
                <label>Telefone 1: celular
                  <a :href="whatsLink(locadorTelefone1)" target="_blank">
                    <img src="/img/whatsapp.jpeg" class="whatsapp-icon" v-if="locadorTelefone1 != ''"/>
                  </a>
                </label>
                <input type="text" v-model="locadorTelefone1" class="form-control" v-mask="'##-#########'"/>
              </div>
              <div class="form-group">
                <label>Telefone 2:</label>
                <input type="text" v-model="locadorTelefone2" class="form-control" v-mask="'##-#########'"/>
              </div>
              <div class="form-group">
                <label>Email:</label>
                <input type="email" v-model="locadorEmail" class="form-control"/>
              </div>
              <div class="form-group">
                <label>CPF:</label>
                <input type="text" v-model="locadorCPF" class="form-control"/>
              </div>
              <div class="form-group mb-0">
                <label>Outras informações:</label>
                <textarea v-model="locadorObs" class="form-control" rows="2"></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- Dados Locatário -->
        <div class="col-sm-6">
          <div class="card locacao-card mb-4 h-100">
            <div class="locacao-card-header">
              <h5 class="mb-0">Dados do Locatário</h5>
            </div>
            <div class="locacao-card-body">
              <div class="form-group">
                <label>Nome:</label>
                <input type="text" v-model="locatarioNome" class="form-control"/>
              </div>
              <div class="form-group">
                <label>Telefone 1: celular
                  <a :href="whatsLink(locatarioTelefone1)" target="_blank">
                    <img src="/img/whatsapp.jpeg" class="whatsapp-icon" v-if="locatarioTelefone1 != ''"/>
                  </a>
                </label>
                <input type="text" v-model="locatarioTelefone1" class="form-control" v-mask="'##-#########'"/>
              </div>
              <div class="form-group">
                <label>Telefone 2:</label>
                <input type="text" v-model="locatarioTelefone2" class="form-control" v-mask="'##-#########'"/>
              </div>
              <div class="form-group">
                <label>Email:</label>
                <input type="email" v-model="locatarioEmail" class="form-control"/>
              </div>
              <div class="form-group">
                <label>CPF:</label>
                <input type="text" v-model="locatarioCPF" class="form-control"/>
              </div>
              <div class="form-group mb-0">
                <label>Outras informações:</label>
                <textarea v-model="locatarioObs" class="form-control" rows="2"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Observações -->
      <div class="card locacao-card mb-5">
        <div class="locacao-card-header">
          <h5 class="mb-0">Observações</h5>
        </div>
        <div class="locacao-card-body">
          <textarea v-model="obs" class="form-control" rows="3"></textarea>
        </div>
      </div>

      <!-- Botão Salvar -->
      <div class="text-center mt-4 mb-4">
        <button @click="add()" type="button" class="btn btn-salvar" :disabled="loading">
          <span v-if="!loading">SALVAR ALTERAÇÕES</span>
          <span v-else><span class="spinner-border spinner-border-sm mr-2"></span>Salvando...</span>
        </button>
      </div>
    </form>

    <!-- Toast Sucesso -->
    <transition name="toast-fade">
      <div v-if="showStatus" class="toast-sucesso" @click="showStatus = false">
        <span class="toast-icon">&#10003;</span>
        Informações atualizadas com sucesso!
      </div>
    </transition>

    <!-- Documentos -->
    <div v-show="showUploads" class="card locacao-card mb-5 mt-4">
      <div class="locacao-card-header">
        <h5 class="mb-0">Documentos da Locação</h5>
      </div>
      <div class="locacao-card-body">
        <div class="row mb-3">
          <div class="form-group col-sm-4">
            <label>Nome do Documento:</label>
            <input type="text" v-model="novoNomeDoc" class="form-control" placeholder="Ex: Contrato Assinado">
          </div>
          <div class="form-group col-sm-4">
            <label>Selecionar Arquivo:</label>
            <input type="file" ref="fileInput" class="form-control" @change="selecionarArquivo">
          </div>
          <div class="form-group col-sm-4 d-flex align-items-end">
            <button class="btn btn-enviar" @click="uploadDocumento">Enviar</button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-docs mb-0" v-if="documentos.length > 0">
            <thead>
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="doc in documentos" :key="doc.DOC_ID">
                <td>{{doc.DOC_DATA || ''}}</td>
                <td>{{doc.DOC_NOME}}</td>
                <td>
                  <a :href="'https://www2.royaljardim.com.br/sistema/uploads/' + doc.DOC_ARQUIVO" target="_blank" class="btn btn-sm btn-outline-info">Visualizar</a>
                  <button class="btn btn-sm btn-outline-danger ml-1" @click="excluirDocumento(doc.DOC_ID)">Excluir</button>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="text-muted text-center py-3 mb-0">Nenhum documento encontrado.</p>
        </div>
      </div>
    </div>

    <!-- Modal Exibição Imóvel -->
    <modal name="my-first-modal">
      <section class="p-3">
        <exibicaoImovel v-if="referencia != ''" :lead.sync="referencia"/>
      </section>
    </modal>

    <!-- Modal Alerta Renovação Aluguel -->
    <modal name="modal-renovacao-aluguel" :adaptive="true"
      classes="vue-modal-renovacao" width="450px" height="auto">
      <div class="modal-renovacao-header">
        <span class="modal-renovacao-icon">!</span>
        <h5>Atenção - Renovação do Aluguel</h5>
      </div>
      <div class="modal-renovacao-body">
        <p>
          A renovação do aluguel está próxima!
          Faltam <strong>{{ diasRestantesRenovacaoAluguel }}</strong>
          para o vencimento em <strong>{{ dataRenovacaoAluguelFormatada }}</strong>.
        </p>
        <p>Por favor, atualize a data de renovação.</p>
      </div>
      <div class="modal-renovacao-footer">
        <button class="btn btn-sm btn-warning" @click="fecharModalRenovacaoAluguel">
          Entendi
        </button>
      </div>
    </modal>

    <!-- Botão de acesso rápido - Buscar Locações -->
    <router-link to="/buscaLocacoes" class="fab-buscar-locacoes" title="Buscar Locações">
      <span class="fab-icone">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </span>
      <span class="fab-texto">Buscar Locações</span>
    </router-link>

    <!-- Navegação por Ícones (rodapé) -->
    <CardNavLocacao :pasta="pasta" class="mt-4" />

  </div>
</template>

<style scoped>
/* ===== Container ===== */
.locacao-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* ===== Cards de Seção ===== */
.locacao-card {
  border: 1px solid #e8e4e3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.locacao-card-header {
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px 10px 0 0;
}
.locacao-card-header h3,
.locacao-card-header h5 {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.locacao-card-header h3 {
  font-size: 17px;
}
.locacao-card-body {
  padding: 20px;
  background: #fff;
}
.badge-campo {
  font-size: 14px;
  color: #555;
}

/* ===== Labels e Inputs ===== */
.locacao-card label {
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 5px;
}
.locacao-card .form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 9px 12px;
  font-size: 14px;
  transition: all 0.2s;
}
.locacao-card .form-control:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
}
.locacao-card select.form-control {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cpath fill='%234C1C17' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 32px;
}
.locacao-card .form-control[readonly] {
  background: #f8f6f5;
  color: #666;
}

/* ===== Dias Renovação ===== */
.campo-vencido {
  background: #ffe5e5 !important;
  color: #dc3545 !important;
  border-color: #f5c6cb !important;
  font-weight: 600;
}
.campo-ok {
  background: #e8f5e9 !important;
  color: #28a745 !important;
  border-color: #c3e6cb !important;
  font-weight: 600;
}

/* ===== WhatsApp Icon ===== */
.whatsapp-icon {
  width: 22px;
  height: 22px;
  vertical-align: middle;
  margin-left: 6px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.whatsapp-icon:hover {
  opacity: 1;
}

/* ===== Botão Visualizar ===== */
.btn-visualizar {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(212, 160, 23, 0.3);
}
.btn-visualizar:hover {
  background: linear-gradient(135deg, #e6b422, #d4a017);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(212, 160, 23, 0.4);
}

/* ===== Botão Lista Locações ===== */
.btn-lista-locacoes {
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.4);
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-lista-locacoes:hover {
  background: rgba(255,255,255,0.25);
  color: #fff;
  border-color: rgba(255,255,255,0.6);
  transform: translateY(-1px);
}

/* ===== Botão Enviar ===== */
.btn-enviar {
  background: linear-gradient(135deg, #28a745, #218838);
  color: #fff;
  border: none;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}
.btn-enviar:hover {
  background: linear-gradient(135deg, #34ce57, #28a745);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(40, 167, 69, 0.4);
}

/* ===== Botão Salvar ===== */
.btn-salvar {
  background: #4C1C17;
  color: #fff;
  border: none;
  padding: 12px 48px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 8px;
  transition: all 0.2s;
}
.btn-salvar:hover:not(:disabled) {
  background: #6b2a22;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(76,28,23,0.3);
}
.btn-salvar:disabled {
  opacity: 0.7;
  cursor: wait;
}

/* ===== Toast Sucesso ===== */
.toast-sucesso {
  position: fixed;
  top: 80px;
  right: 24px;
  background: #28a745;
  color: #fff;
  padding: 14px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  z-index: 9999;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  animation: toastSlideIn 0.3s ease;
}
.toast-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255,255,255,0.25);
  margin-right: 10px;
  font-size: 14px;
}
@keyframes toastSlideIn {
  from { transform: translateX(120%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}
.toast-fade-enter-active { animation: toastSlideIn 0.3s ease; }
.toast-fade-leave-active { animation: toastSlideIn 0.3s ease reverse; }

/* ===== Tabela Documentos ===== */
.table-docs thead {
  background: #4C1C17;
  color: #fff;
}
.table-docs th {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}
.table-docs td {
  padding: 12px 16px;
  vertical-align: middle;
  font-size: 14px;
}
.table-docs tbody tr:hover {
  background: #f8f4f3;
}
.table-docs tbody tr:last-child td {
  border-bottom: none;
}

/* ===== FAB Buscar Locações ===== */
.fab-buscar-locacoes {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  padding: 14px 22px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(76,28,23,0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}
.fab-icone svg {
  width: 24px;
  height: 24px;
}
.fab-texto {
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  transition: all 0.3s ease;
}
.fab-buscar-locacoes:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(76,28,23,0.5);
}
.fab-buscar-locacoes:hover .fab-texto {
  max-width: 140px;
  opacity: 1;
}
.fab-buscar-locacoes::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50px;
  border: 2px solid #4C1C17;
  animation: fabPulse 2s infinite;
}
@keyframes fabPulse {
  0%   { transform: scale(1);   opacity: 0.8; }
  70%  { transform: scale(1.12); opacity: 0; }
  100% { transform: scale(1.12); opacity: 0; }
}

/* ===== Modal Renovação ===== */
.vue-modal-renovacao {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(76, 28, 23, 0.25);
}
.modal-renovacao-header {
  background: #4C1C17;
  color: #fff;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.modal-renovacao-header h5 {
  margin: 0;
  color: #fff;
  font-weight: bold;
}
.modal-renovacao-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #dc3545;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  flex-shrink: 0;
}
.modal-renovacao-body {
  padding: 20px;
  color: #333;
  font-size: 15px;
  line-height: 1.6;
}
.modal-renovacao-body strong {
  color: #4C1C17;
}
.modal-renovacao-footer {
  padding: 12px 20px 16px;
  text-align: right;
}
</style>

<style>
/* Estilos globais (vue-js-modal) */
.vue-modal-renovacao {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(76, 28, 23, 0.25);
}
</style>

<script>
import axios from 'axios'
import CardNavLocacao from '@/components/CardNavLocacao'


export default {
  name: 'Locacao',
  components: {
    ExibicaoImovel: () => import('@/components/ExibicaoImovel'),
    CardNavLocacao
  },
  data(){
    return {
      reajuste:'',
      responsavel:'',
      acao: 1,
      pasta:'',
      referencia:'',
      garantia:'',
      tempo:'',
      dia:'',
      porcentagem:5,
      selectedDate:'',
      valor:'0,00',
      valor2:'3,80',
      valor3:'',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      loading:false,
      showStatus:false,
      showUploads:false,
      // Locador
      locadorNome:'',
      locadorTelefone1:'',
      locadorTelefone2:'',
      locadorEmail:'',
      locadorCPF:'',
      locadorObs:'',
      // Locatario
      locatarioNome:'',
      locatarioTelefone1:'',
      locatarioTelefone2:'',
      locatarioEmail:'',
      locatarioCPF:'',
      locatarioObs:'',
      // Repasse
      repasse:'',
      pix:'CPF',
      obs:'',
       seguradora:'',
      renovadoAte:'', // Date object
      renovacaoContrato:'',
      renovacaoAluguel:'',
      // Documentos
      documentos:[],
      novoNomeDoc:'',
      arquivoSelecionado:null,
    }
  },
  computed:{
    renovacaoVencida() {
    // vazio OU vencido
    return this.diasRenovacaoCalc == '' || this.diasRenovacaoCalc == 'Seguro vencido' || this.diasRenovacaoCalc == "0 dias";
  },
  diasRenovacaoCalc(){
    if(!this.renovadoAte) return "";
    let hoje = new Date();
    let renov = new Date(this.renovadoAte);

    // zerar horas para não dar diferença por fuso
    hoje.setHours(0,0,0,0);
    renov.setHours(0,0,0,0);

    let diff = renov - hoje; // diferença em ms
    let dias = Math.ceil(diff / (1000 * 60 * 60 * 24));

    return dias >= 0 ? dias + " dias" : "Seguro vencido";
  },
  diasRestantesRenovacaoAluguel() {
    if (!this.renovacaoAluguel) return '';
    let hoje = new Date();
    let renov = new Date(this.renovacaoAluguel);
    hoje.setHours(0,0,0,0);
    renov.setHours(0,0,0,0);
    let diff = renov - hoje;
    let dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return dias >= 0 ? dias + ' dias' : 'Vencido';
  },
  dataRenovacaoAluguelFormatada() {
    if (!this.renovacaoAluguel) return '';
    let d = new Date(this.renovacaoAluguel);
    return d.toLocaleDateString('pt-BR');
  },
    valorTaxa(){
      let v = parseFloat(this.valor.replace("R$", "").trim().replace(/\./g, "").replace(",", "."));
      if(isNaN(v)) v = 0;
      let retorno = (this.porcentagem/100) * v;
      return retorno.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
    },
    fimContrato(){
    
      if(this.selectedDate && this.tempo && this.renovacaoContrato == ''){
        let fim = new Date(this.selectedDate);
        fim.setMonth(fim.getMonth() + Number(this.tempo));
        return fim.toLocaleDateString("pt-BR");
      }

       if(this.renovacaoContrato && this.tempo){
        let fim = new Date(this.renovacaoContrato);
        fim.setMonth(fim.getMonth() + Number(this.tempo));
        return fim.toLocaleDateString("pt-BR");
      }

      return "";
    }
  },
  methods:{
     showImovel(){
            this.$modal.show('my-first-modal');
        },

    verificarAlertaRenovacaoAluguel() {
      if (!this.renovacaoAluguel) return;
      if (this.diasRestantesRenovacaoAluguel !== '' && this.diasRestantesRenovacaoAluguel !== 'Vencido') {
        let dias = parseInt(this.diasRestantesRenovacaoAluguel);
        if (!isNaN(dias) && dias <= 30 && dias >= 0) {
          this.$modal.show('modal-renovacao-aluguel');
        }
      }
    },
    fecharModalRenovacaoAluguel() {
      this.$modal.hide('modal-renovacao-aluguel');
    },

    whatsLink(num){
    if(!num) return '#';
    // remove tudo que não for número
    let digits = num.replace(/\D/g, '');
    // adiciona DDI do Brasil se tiver só DDD+numero
    if(digits.length === 10 || digits.length === 11){
      digits = '55' + digits;
    }
    return `https://wa.me/${digits}`;
  },
     filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".").trim();
    },
    selecionarArquivo(e){ this.arquivoSelecionado = e.target.files[0]; },
    uploadDocumento(){
      if(!this.arquivoSelecionado || !this.novoNomeDoc){
        alert("Selecione um arquivo e informe um nome.");
        return;
      }
      let formData = new FormData();
      formData.append("pasta", this.pasta);
      formData.append("nome", this.novoNomeDoc);
      formData.append("arquivo", this.arquivoSelecionado);
      axios.post("https://www2.royaljardim.com.br/sistema/locacao/uploadDocumento", formData, {
        headers:{'Content-Type':'multipart/form-data'}
      }).then(()=>{this.getDocumentos();this.novoNomeDoc='';this.$refs.fileInput.value='';})
    },
    getDocumentos(){
      axios.post("https://www2.royaljardim.com.br/sistema/locacao/getDocumentos",{pasta:this.pasta})
        .then(res=>this.documentos=res.data);
    },
    excluirDocumento(id){
      if(confirm("Deseja excluir este documento?")){
        axios.post("https://www2.royaljardim.com.br/sistema/locacao/deleteDocumento",{id:id})
          .then(()=>this.getDocumentos());
      }
    },
    add(){
      this.loading = true;
      let formData = new FormData(this.$refs["formulario"]);
      formData.append('corretor',this.getUsuario());
           formData.append('valor',this.filtrar(this.valor));
           formData.append('valor2',this.filtrar(this.valor2));
           formData.append('valor3',this.filtrar(this.valorTaxa));
           // Identificação
  formData.append('pasta', this.pasta);
  formData.append('referencia', this.referencia);

    // Contrato
  formData.append('garantia', this.garantia);
  formData.append('seguradora', this.seguradora);
  formData.append('tempo', this.tempo);
  formData.append('dia', this.dia);
  formData.append('porcentagem', this.porcentagem);
  formData.append('reajuste', this.reajuste);
  formData.append('responsavel', this.responsavel);
  // Locador
  formData.append('locadorNome', this.locadorNome);
  formData.append('locadorTelefone1', this.locadorTelefone1);
  formData.append('locadorTelefone2', this.locadorTelefone2);
  formData.append('locadorEmail', this.locadorEmail);
  formData.append('locadorCPF', this.locadorCPF);
  formData.append('locadorObs', this.locadorObs);

  // Locatário
  formData.append('locatarioNome', this.locatarioNome);
  formData.append('locatarioTelefone1', this.locatarioTelefone1);
  formData.append('locatarioTelefone2', this.locatarioTelefone2);
  formData.append('locatarioEmail', this.locatarioEmail);
  formData.append('locatarioCPF', this.locatarioCPF);
  formData.append('locatarioObs', this.locatarioObs);
  // Repasse / PIX
  formData.append('repasse', this.repasse);
  formData.append('pix', this.pix);

  // Observações gerais
  formData.append('obs', this.obs);


      if(this.selectedDate){
        let d = new Date(this.selectedDate);
        let dd = String(d.getDate()).padStart(2,'0');
        let mm = String(d.getMonth()+1).padStart(2,'0');
        let inicio = d.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('dataInicio',inicio);
      }
       if(this.renovadoAte){
        let r = new Date(this.renovadoAte);
        let dd = String(r.getDate()).padStart(2,'0');
        let mm = String(r.getMonth()+1).padStart(2,'0');
        let renov = r.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('renovadoAte', renov);
      }

      if(this.renovacaoContrato){
        let r = new Date(this.renovacaoContrato);
        let dd = String(r.getDate()).padStart(2,'0');
        let mm = String(r.getMonth()+1).padStart(2,'0');
        let renov = r.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('renovacaoContrato', renov);
      }

      if(this.renovacaoAluguel){
        let r = new Date(this.renovacaoAluguel);
        let dd = String(r.getDate()).padStart(2,'0');
        let mm = String(r.getMonth()+1).padStart(2,'0');
        let renov = r.getFullYear()+"-"+mm+"-"+dd+" 00:00";
        formData.append('renovacaoAluguel', renov);
      }
   

      axios.post('https://www2.royaljardim.com.br/sistema/locacao/criar',formData)
        .then((res)=>{console.log(res.data);this.loading=false;this.showStatus=true;this.showUploads=true;this.acao = 2;})
    },
    get(){
      axios.post('https://www2.royaljardim.com.br/sistema/locacao/getLocacao',{pasta:this.pasta})
        .then(r=>this.updateInfo(r.data))
    },
    updateInfo(data){
        this.pasta=data.LOC_PASTA||'';
      this.referencia=data.LOC_IMOVEL||'';
      this.garantia=data.LOC_GARANTIA||'';
       this.reajuste=data.LOC_REAJUSTE||'';
         this.responsavel=data.LOC_RESPONSAVEL||'';
      this.tempo=data.LOC_TEMPO_CONTRATO||'';
      this.dia=data.LOC_VENCIMENTO||'';
      this.porcentagem=data.LOC_PORCENTAGEM||0;
      this.valor=data.LOC_ALUGUEL||'0,00';
      this.valor2=data.LOC_BOLETO||'0,00';
      this.valor3=data.LOC_VALOR_ADM||'';
      this.locadorNome=data.LOC_LOCADOR||'';
      this.locatarioNome=data.LOC_LOCATARIO||'';
      this.locadorEmail=data.LOC_LOCADOR_EMAIL||'';
      this.locatarioEmail=data.LOC_EMAIL_LOCATARIO||'';
      this.pix=data.LOC_PIX||'';
      this.obs=data.LOC_OBSERVACAO||'';
      this.locadorTelefone1 = data.LOC_LOCADOR_TELEFONE1 || '';
      this.locadorTelefone2 = data.LOC_LOCADOR_TELEFONE2 || '';
      this.locadorCPF = data.LOC_LOCADOR_CPF || '';
      this.locadorObs = data.LOC_LOCADOR_OBS || '';
      this.locatarioTelefone1 = data.LOC_LOCATARIO_TELEFONE1 || '';
      this.locatarioTelefone2 = data.LOC_LOCATARIO_TELEFONE2 || '';
      this.locatarioCPF = data.LOC_LOCATARIO_CPF || '';
      this.locatarioObs = data.LOC_LOCATARIO_OBS || '';
       this.acao = 2;
      // NOVOS CAMPOS (seguradora / renovado / dias)
      this.seguradora = data.LOC_SEGURADORA || '';
       this.repasse = data.LOC_REPASSE || '';
     
      if(data.LOC_RENOVADO_ATE){
        // parse seguro: usar parte Y-M-D e construir Date local
        let ymd = data.LOC_RENOVADO_ATE.split(" ")[0];
        let parts = ymd.split("-");
        if(parts.length === 3){
          this.renovadoAte = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else {
          // fallback: tentativa direta
          let d = new Date(data.LOC_RENOVADO_ATE);
          d.setDate(d.getDate() + 1);
          this.renovadoAte = d;
        }
      } else {
        this.renovadoAte = '';
      }

      //////
   if(data.LOC_RENOVACAOCONTRATO){
        // parse seguro: usar parte Y-M-D e construir Date local
        let ymd = data.LOC_RENOVACAOCONTRATO.split(" ")[0];
        let parts = ymd.split("-");
        if(parts.length === 3){
          this.renovacaoContrato = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else {
          // fallback: tentativa direta
          let d = new Date(data.LOC_RENOVACAOCONTRATO);
          d.setDate(d.getDate() + 1);
          this.renovacaoContrato = d;
        }
      } else {
        this.renovacaoContrato = '';
      }

      if(data.LOC_RENOVACAO_ALUGUEL){
        let ymd = data.LOC_RENOVACAO_ALUGUEL.split(" ")[0];
        let parts = ymd.split("-");
        if(parts.length === 3){
          this.renovacaoAluguel = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else {
          let d = new Date(data.LOC_RENOVACAO_ALUGUEL);
          d.setDate(d.getDate() + 1);
          this.renovacaoAluguel = d;
        }
      } else {
        this.renovacaoAluguel = '';
      }
      ////

      if(data.LOC_INICIO_CONTRATO){
        let d = new Date(data.LOC_INICIO_CONTRATO);
        d.setDate(d.getDate()+1);
        this.selectedDate=d;
      }
      this.showUploads=true;
      this.getDocumentos();
    },
      getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     getUsuarioID(){
       return sessionStorage.getItem('imobiliariaID');
     },
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }
  },
  mounted(){
    if(this.$route.params.id){
      this.pasta=this.$route.params.id;
      this.get();
      setTimeout(() => this.verificarAlertaRenovacaoAluguel(), 1500);
    }
  }
}
</script>
